import { render, staticRenderFns } from "./ManterAtualizacaoCadastralView.vue?vue&type=template&id=52de263c&scoped=true"
import script from "./ManterAtualizacaoCadastralView.vue?vue&type=script&lang=js"
export * from "./ManterAtualizacaoCadastralView.vue?vue&type=script&lang=js"
import style0 from "./ManterAtualizacaoCadastralView.vue?vue&type=style&index=0&id=52de263c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de263c",
  null
  
)

export default component.exports